export const STRIPE_CHECKOUT_RETURN_SESSION_PARAM = 'session_id'

const STRIPE_RETURN_QUERY_PARAMS = [STRIPE_CHECKOUT_RETURN_SESSION_PARAM] as const

export function getStripeCheckoutReturnSessionId(searchParams: URLSearchParams): string | null {
    const sessionId = searchParams.get(STRIPE_CHECKOUT_RETURN_SESSION_PARAM)?.trim()
    if (!sessionId?.startsWith('cs_')) {
        return null
    }
    return sessionId
}

export function clearStripeCheckoutReturnParams(pathname: string, searchParams: URLSearchParams): string {
    const params = new URLSearchParams(searchParams.toString())
    for (const key of STRIPE_RETURN_QUERY_PARAMS) {
        params.delete(key)
    }
    const query = params.toString()
    return query.length > 0 ? `${pathname}?${query}` : pathname
}
